import { render, staticRenderFns } from "./CardSmall.vue?vue&type=template&id=e18a0428&"
import script from "./CardSmall.vue?vue&type=script&lang=js&"
export * from "./CardSmall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports